



































































































































































import {
  computed,
  defineComponent,
  ref,
  unref,
  useContext,
  useRouter,
} from "@nuxtjs/composition-api"
import { AxiosError } from "axios"

import useMessageApiErrorI18n from "@/composables/useMessageApiError"
import useToast from "@/composables/useToast"
import { Roles } from "@/enums"
import { UpdateUserPayload } from "@/types/apiPayloads/UpdateUserPayload"
import { ApiError } from "@/types/models/ApiError"

export default defineComponent({
  name: "TopMenu",
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, { root: { $bvToast } }) {
    const context = useContext()
    const router = useRouter()
    const showTopMenu = ref(false)
    const currentUser = computed(() => context.app.$accessor.user.currentUser)
    const { createToast } = useToast($bvToast)

    const currentUserRole = computed(
      () => context.app.$accessor.user.currentUserRole,
    )

    const isProfessional = computed(
      () => currentUserRole.value === context.app.$enums.Roles.PROFESSIONAL,
    )

    const isLoggedIn = computed(() =>
      Boolean(context.app.$accessor.user.currentUser),
    )

    const isLoggedInAndEmailVerified = computed(
      () =>
        Boolean(context.app.$accessor.user.currentUser) &&
        Boolean(
          context.app.$accessor.user.isEmailVerified ||
            context.app.$accessor.user.isProfessionalVerified,
        ),
    )
    const { formatErrorMessage } = useMessageApiErrorI18n()

    const update = async (datas: any) => {
      await context.app.$accessor.user
        .updateUser({ data: datas })
        .catch((error: AxiosError<ApiError>) => {
          createToast(
            context.app.$enums.ToastVariants.DANGER,
            `${context.app.i18n.t("global.error")}`,
            2000,
            {
              message: formatErrorMessage(error, context.app),
            },
          )
        })
    }

    const switchRole = async () => {
      const user = unref(currentUser)
      if (!user) return
      const roleToChange = isProfessional.value
        ? Roles.CUSTOMER
        : Roles.PROFESSIONAL

      const data = {
        userData: {
          selectedRole: roleToChange,
        },
      }
      await update(data)
      router.go(0)
    }

    const changeLanguage = (locale: string) => {
      context.app.i18n.setLocale(locale)

      const data = {
        userData: {
          selectedLocale: locale,
        },
      } as Partial<UpdateUserPayload["userData"]>
      update(data)
    }

    const hasBothRoles = computed(
      () =>
        Boolean(currentUser.value?.customerData) &&
        Boolean(currentUser.value?.professionalData),
    )

    const logOut = () => {
      router.push(
        context.app.localePath({ path: context.app.$enums.AppPaths.LOGOUT }),
      )
    }

    const checkCurrentPage = (event: PointerEvent) => {
      const aNuxtLink = event.target as HTMLLinkElement
      if (aNuxtLink.classList.contains("nuxt-link-exact-active")) {
        showTopMenu.value = false
      }
    }

    const goToLogin = () => {
      router.push({
        path: context.app.$enums.AppPaths.LOGIN,
      })
    }

    return {
      logOut,
      goToLogin,
      changeLanguage,
      checkCurrentPage,
      isLoggedIn,
      showTopMenu,
      isProfessional,
      isLoggedInAndEmailVerified,
      switchRole,
      hasBothRoles,
    }
  },
})
